module.exports = "/dist/images/ac5c9076e316121e7f70679fd6e80ecb-myaccount.jpg";